import { FormatListBulletedRounded } from '@mui/icons-material'
import { styled } from '@mui/material/styles'
import { ActiveHeaderIconButton } from './common'
import { colorPalette } from '../../../../style/colorPalette'
import { Tooltip } from '@mui/material'
import { intl } from '../../../../../i18n'

interface ReportMenuButtonProps {
  isOpen: boolean
  onToggle: () => void
}

const StyledIcon = styled(FormatListBulletedRounded)<{ isOpen: boolean }>(
  ({ theme, isOpen }) => ({
    color: isOpen ? colorPalette.monotone[0] : colorPalette.monotone[4],
    transition: theme.transitions.create('color', {
      duration: theme.transitions.duration.short,
    }),
  })
)

export const ReportMenuButton = ({
  isOpen,
  onToggle,
}: ReportMenuButtonProps) => {
  return (
    <Tooltip
      title={intl.formatMessage({
        id: 'versionReport.tooltip.selectReport',
      })}
    >
      <ActiveHeaderIconButton active={isOpen} onClick={onToggle}>
        <StyledIcon isOpen={isOpen} />
      </ActiveHeaderIconButton>
    </Tooltip>
  )
}
